
import React from 'react'
const Footer: React.FC = () => {
  return (
        <>
            <div id="footer" className="bg-gray-100 py-4" >
                <div className="md:container mx-auto px-4 sm:px-20 md:px-24 lg:px-28 xl:px-36">
                    <div className="text-sm flex justify-center">@ Ross Street Masjid 2026</div>
                </div>
            </div>
        </>
  )
}

export default Footer
